import { Flex, Box } from "@chakra-ui/react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { Outlet } from "react-router-dom";

const Layout = (): JSX.Element => {
  return (
    <Flex direction={"column"}>
      <Box width={"full"} height={100}>
        <Header />
      </Box>

      <Box width={"full"} paddingX={12}>
        <Outlet />
      </Box>

      <Box marginTop={100} width={"full"}>
        <Footer />
      </Box>

      <Box
        position="fixed"
        left="0"
        top="50%"
        transform="translateY(-50%) rotate(180deg)"
        color="white"
        letterSpacing={10}
        fontSize={"small"}
        sx={{
          writingMode: "vertical-rl",
          textOrientation: "mixed",
        }}
      >
        manishparui.com
      </Box>
    </Flex>
  );
};

export default Layout;
